import React from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooterConfirmDismiss,
    icons,
    HorizontalFlex
} from 'smartsuite-ui';

export default function ConfirmModal(props) {
    return (
        props.isModalVisible && (
            <Modal onOverlayClick={() => {}}>
                {props.confirmTitle && (
                    <ModalHeader onDismiss={props.onDismiss}>
                        {props.confirmTitle}
                    </ModalHeader>
                )}
                <ModalBody>
                    <HorizontalFlex>
                        <span
                            className={`confirm-modal__icon ${icons.warningFilled}`}
                        />
                        {props.children}
                    </HorizontalFlex>
                </ModalBody>
                <ModalFooterConfirmDismiss
                    confirmLabel={props.confirmLabel}
                    dismissLabel={props.dismissLabel}
                    onConfirm={props.onConfirm}
                    onDismiss={props.onDismiss}
                />
            </Modal>
        )
    );
}

ConfirmModal.propTypes = {
    children: PropTypes.node.isRequired,
    confirmTitle: PropTypes.string,
    confirmLabel: PropTypes.string.isRequired,
    dismissLabel: PropTypes.string.isRequired,
    isModalVisible: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired
};

ConfirmModal.defaultProps = {
    confirmTitle: '',
    isModalVisible: true
};
